const DietStayTypes = {
    Hotel: 1,
    DormOrBarracksWithCooking: 2,
    BoardingHouseWithoutCooking: 3,
    NightAddition: 4
};

Object.freeze(DietStayTypes);

export default DietStayTypes;